// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  defaultStatus: "",
  tableloading: true,
  category: [],
  subCategory: [],
  merchantTax: "",
  secondData: [],
  secondTotal: 1,
  secondParams: {}
};

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DATA":
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        category: action.category,
        subCategory: action.subCategory,
        defaultStatus: action.defaultStatus ? action.defaultStatus : "",
        merchantTax: action.merchantTax ? action.merchantTax : "",
      };
    case "GET_DATA_OTHER":
      return {
        ...state,
        secondData: action.data,
        secondTotal: action.totalPages,
        secondParams: action.params,
      };

    case "SET_TABLE_LOADING":
      return { ...state, tableloading: action.value };
    default:
      return state;
  }
};

export default DataTablesReducer;
